import { c as _c } from "react/compiler-runtime";
import useSWR from "swr";
import { fetchJsonArray } from "./stopSearchResource.js";
export function useMapSearchResults(key) {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      revalidateOnMount: true,
      dedupingInterval: 60000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useSWR(key, fetchJsonArray, t0);
}